module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("NewPassword", "Set a new password") ))==null?'':__t)+
'</legend><div><label for="new-password-one-input">'+
((__t=( i18n.tc("NewPassword", "New password:") ))==null?'':__t)+
'</label> <input type="password" id="new-password-one-input" data-input="new-password-one" required></div><div><label for="new-password-two-input">'+
((__t=( i18n.tc("NewPassword", "Repeat password:") ))==null?'':__t)+
'</label> <input type="password" id="new-password-two-input" data-input="new-password-two" required></div></fieldset><fieldset class="button-wrap"><button class="primary" data-click="new-password-submit" disabled="disabled">'+
((__t=( i18n.tc("NewPassword", "Submit") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
